import { render } from "./Rows.vue?vue&type=template&id=31386e6c&scoped=true"
import script from "./Rows.vue?vue&type=script&lang=js"
export * from "./Rows.vue?vue&type=script&lang=js"

import "./Rows.vue?vue&type=style&index=0&id=31386e6c&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31386e6c"]])

export default __exports__